export const ACCEPTED_FILE_TYPES =
  ".avi,.css,.csv,.doc,.docx,.gif,.htm,.html,.jpeg,.jpg,.m4v,.mkv,.mov,.mp3,.mp4,.mpeg,.mpg,.ogg,.pdf,.png,.ppt,.pptx,.tar,.txt,.wav,.wmv,.xls,.xlsx,.xml,.zip";
